import React from 'react';
import { render } from 'react-dom';
import WidgetCalendar from './react-components/WidgetCalendar.js';
import '../css/calendar-widget.css';

const container = document.querySelector('.sidebar #calendar');

if (container) {
	render(<WidgetCalendar />, container);
}
